/** Public source checked 2026-09-21; count rounded because it changes over time. */
export const COMPANY_REVIEWS = {
  platform: "Reco",
  rating: "4,6",
  ratingLabel: "4,6/5 på Reco",
  countLabel: "Över 1 300 omdömen",
  sourceUrl: "https://www.reco.se/nordiska-inglasningar-ab",
  checkedAt: "2026-09-21",
} as const;

/** Business answers J1–J4/I3, saved 2026-09-21; contact address verified on the corporate contact page.
 * Operating start (2012) is not the company's legal registration date (2008).
 * Project volume below covers balcony glazing, not completed conservatories.
 */
export const COMPANY_FACTS = {
  legalName: "Nordiska Inglasningar & Profilsystem AB",
  organizationNumber: "556753-0802",
  operatingSince: 2012,
  balconyCountLabel: "Cirka 18 000 inglasade balkonger",
  headquarters: {
    streetAddress: "Abramsons väg 2",
    postalCode: "632 39",
    city: "Eskilstuna",
  },
  salesOffice: {
    streetAddress: "Gjuterivägen 13",
    postalCode: "168 67",
    city: "Bromma",
    visits: "Efter bokning",
  },
  contactSource: "https://www.nordiskainglasningar.se/kontakt/",
  reviewedAt: "2026-09-21",
} as const;
